module.exports = __webpack_public_path__ + "img/boton-historico.d078012f.jpg";